import gql from "graphql-tag";

export const dunegql = gql;

// The line below is required by codegen for some reason
// ts-unused-exports:disable-next-line
export default dunegql;
